import { RootStateOrAny } from 'react-redux';

export const getCurrentUser = (state: RootStateOrAny) => {
  return state.UserReducer?.userInfo?.data?.payload;
};

export const getIsUserLoaded = (state: RootStateOrAny) => {
  const userData = state.UserReducer?.userInfo;
  return !!userData;
};

export const getIsFranchiseUser = (state: RootStateOrAny) => {
  const userData = state.UserReducer?.userInfo?.data?.payload;
  return userData?.userType === 'Franchise';
};

export const getFranchiseDefaultReportingUnit = (state: RootStateOrAny) => {
  const [defaultReportingUnit] =
    state.UserReducer?.userInfo?.data?.payload?.reportingUnitIds;
  return defaultReportingUnit;
};
